export type Metadata = { clientUuid?: string | undefined; error?: Error } | Record<string, unknown>;

export const SUCCESS_EVENTS = {
  checkout_pt_user_convert_to_client_success: (metadata: Metadata, value) => ({
    target: 'User Conversion',
    label: 'Convert success',
    metadata,
    value,
  }),
  checkout_promo_code_applied: (metadata: Metadata, value) => ({
    target: 'Promo Code',
    label: 'Promo code applied',
    metadata,
    value,
  }),
  checkout_create_account_success: (metadata: Metadata, value) => ({
    target: 'Create account',
    label: 'Create account',
    metadata,
    value,
  }),
  checkout_sign_in_success: (metadata: Metadata, value) => ({
    target: 'Sign in',
    label: 'Sign in',
    metadata,
    value,
  }),
  dropin_info_load_complete: (metadata: Metadata, value) => ({
    target: 'Dropin Info',
    label: 'Load complete',
    metadata,
    value,
  }),
  payment_info_change: (metadata: Metadata, value) => ({
    target: 'checkout',
    label: 'checkout',
    metadata,
    value,
  }),
  checkout_payment_success: (metadata: Metadata, value) => ({
    target: 'Payment',
    label: 'Payment successful',
    metadata,
    value,
  }),
};

export const FAILURE_EVENTS: Record<
  string,
  (
    metadata: Metadata,
    value: any
  ) => { label: string; metadata: Metadata; target: string; value: any }
> = {
  cart_missing_failure: (metadata: Metadata, value) => ({
    target: 'Cart',
    label: 'Missing Catalog Item',
    metadata,
    value,
  }),
  checkout_create_account_failure: (metadata: Metadata, value) => ({
    target: 'Create account',
    label: 'Create account',
    metadata,
    value,
  }),
  checkout_dropin_load_error: (metadata: Metadata, value) => ({
    target: 'checkout',
    label: 'error loading dropin',
    metadata,
    value,
  }),
  checkout_invalid_user: (metadata: Metadata, value) => ({
    target: 'Invalid user',
    label: 'User record has no client',
    metadata,
    value,
  }),
  checkout_payment_failure: (metadata: Metadata, value) => ({
    target: 'Payment',
    label: 'Payment unsuccessful',
    metadata,
    value,
  }),
  checkout_promo_code_not_applied: (metadata: Metadata, value) => ({
    target: 'Promo Code',
    label: 'Promo code not applied',
    metadata,
    value,
  }),
  checkout_pt_user_convert_to_client_failure: (metadata: Metadata, value) => ({
    target: 'User Conversion',
    label: 'Convert failure',
    metadata,
    value,
  }),
  checkout_sign_in_failure: (metadata: Metadata, value) => ({
    target: 'Sign in',
    label: 'Sign in',
    metadata,
    value,
  }),
  dropin_info_load_not_requestable: (metadata: Metadata, value) => ({
    target: 'Dropin Info',
    label: 'Not requestable',
    metadata,
    value,
  }),
};
